import { render } from "./AdaptivePBody.vue?vue&type=template&id=46764074&scoped=true"
import script from "./AdaptivePBody.vue?vue&type=script&lang=js"
export * from "./AdaptivePBody.vue?vue&type=script&lang=js"

import "./AdaptivePBody.vue?vue&type=style&index=0&id=46764074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46764074"]])

export default __exports__